module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-01.06827d78.png";